import _fecthData from './fetchData';

export const fetchData = _fecthData;
export { loadScript } from './loadScript';
